import React from "react";
import { observer } from "mobx-react-lite";
import { ViewDocument } from "../../components/templates/ViewDocument";
import { TypeContractEnum } from "../../enum/contract";
import { env } from "../../config";

const ContractViewer: React.FC = observer(() => (
	<ViewDocument url={env.blob.ccb} type={TypeContractEnum.ANTICIPATION_CONTRACT} />
));

export default ContractViewer;
